import _extends from "@babel/runtime-corejs3/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime-corejs3/helpers/objectWithoutPropertiesLoose";
var _excluded = ["children", "type", "title", "content", "$blocks"];
import { createVNode as h, Component } from 'intact-vue-next';
import { Tooltip } from "../tooltip/tooltip";
import { PopoverContent } from './content';
import { noop } from 'intact-shared';
function Wrapper(props) {
  var children = props.children,
    type = props.type,
    title = props.title,
    content = props.content,
    $blocks = props.$blocks,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  if ($blocks) {
    if ($blocks.title) {
      title = $blocks.title(noop);
    }
    if ($blocks.content) {
      content = $blocks.content(noop);
    }
  }
  var contentVNode = h(PopoverContent, {
    type: type,
    title: title,
    content: content,
    $blocks: $blocks
  });
  return h(Tooltip, _extends({
    children: [children, contentVNode]
  }, rest, {
    confirm: true,
    theme: 'light',
    hoverable: true,
    trigger: 'click'
  }));
}
var functionalWrapper = Component.functionalWrapper;
export var Popover = functionalWrapper ? functionalWrapper(Wrapper) : Wrapper;